import { Box } from "@mui/material";
import React from "react";

interface GreyBoxTitleProps {
  title: string;
}

const GreyBoxTitle: React.FC<GreyBoxTitleProps> = ({ title }) => {
  return (
    <Box sx={{ background: "#F4F3FF", padding: "20px", borderRadius: "16px" }}>
      <h5 style={{ fontWeight: "700", color: "#6458D8" }}>{title}</h5>
    </Box>
  );
};

export default GreyBoxTitle;
